import { render, staticRenderFns } from "./afterSales.vue?vue&type=template&id=1530ee98&scoped=true"
import script from "./afterSales.vue?vue&type=script&lang=ts"
export * from "./afterSales.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530ee98",
  null
  
)

export default component.exports